




































import Vue from "vue";
import { massnahmenServiceInstance } from "@/services/MassnahmenService";
import { OverviewMassnahme } from "@/types/Massnahme";
import { alertError } from "@/services/ErrorAlert";
import SmallTable, { Header, Action } from "@/components/ui/SmallTable.vue";
import AlertService from "@/services/libs/AlertService";
import { RequestError } from "@/services/AuthService";
import SaveDialog from "@/components/dialog/SaveDialog.vue";

export default Vue.extend({
  name: "UmsetzungsTab",
  components: {
    SmallTable,
    SaveDialog,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isLoading: false,
      openSaveDialog: false,
      massnahmen: [] as OverviewMassnahme[],
      massnahmeActions: [
        {
          title: this.editable ? "Massnahme Bearbeiten" : "Massnahme Öffnen",
          type: "is-primary",
          icon: this.editable ? "edit" : "search",
          public: true,
          f: (d: any): void => (this as any).onClick(d, this.editable),
        },
      ] as Action[],
      tableHeader: [
        {
          label: "HWRM-Nr",
          field: "massnahmenNummer",
          sortable: true,
        },
        {
          label: "Benennung",
          field: "bezeichnung",
          sortable: true,
        },
        {
          label: "Art",
          field: "art",
          sortable: true,
        },
        {
          label: "Risikogewässer",
          field: "risikogewaesser",
          sortable: true,
        },
        {
          label: "Status (aktuell)",
          field: "status3",
          sortable: true,
        },
      ] as Header[],
    };
  },
  mounted() {
    this.isLoading = true;
    Promise.all([
      massnahmenServiceInstance
        .getByKommune(this.id)
        .then((data: OverviewMassnahme[]) => (this.massnahmen = data)),
    ])
      .then(() => this.$emit("loaded", this.massnahmen))
      .catch((error: any) => alertError(error))
      .finally(() => (this.isLoading = false));
  },
  methods: {
    onSaveConfirm() {
      this.isLoading = true;
      massnahmenServiceInstance
        .deleteMassnahmen(this.id, this.massnahmen)
        .then((data: OverviewMassnahme[]) => {
          this.massnahmen = data;
          AlertService.info("Maßnahme gelöscht!");
        })
        .catch((error: RequestError) =>
          AlertService.error(
            "Beim Löschen der Maßnahme ist ein Fehler aufgetreten!",
            "Bitte versuchen Sie es in einiger Zeit erneut!",
            "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
            "Fehlermeldung: " + error.message,
          ),
        )
        .finally(() => (this.isLoading = false));
    },

    /** load event to load data */
    onNewMassnahme() {
      this.$router.push({
        name: "MassnahmenDetail",
        params: { id: "undefined" },
        query: { editMode: "true", agKommune: String(this.id) },
      });
    },
    onClick(item: any, editMode: boolean) {
      this.$router.push({
        name: "MassnahmenDetail",
        params: { id: item.id },
        query: editMode ? { editMode: "true" } : {},
      });
    },
  },
});
